module.exports = __webpack_public_path__ + "media/article2_1.79827356.mp4";